import type { SortItem, SortEvent, SortAlgorithm } from '@/core/types';
import { EventRecorderImpl } from '@/core/EventRecorderImpl';

export class SelectionSort implements SortAlgorithm {
  readonly name = 'Selection Sort';
  readonly category = 'comparison' as const;
  readonly stable = false;
  readonly inPlace = true;
  readonly adaptive = false;
  readonly best = 'O(n^2) - always performs full scan for minimum';
  readonly average = 'O(n^2) - typical case';
  readonly worst = 'O(n^2) - worst case identical to average';
  readonly space = 'O(1) - in-place with single temporary storage';

  run(input: SortItem[]): SortEvent[] {
    const recorder = new EventRecorderImpl();
    const arr = input.map(item => ({ ...item }));
    const n = arr.length;

    for (let i = 0; i < n - 1; i++) {
      let minIndex = i;
      for (let j = i + 1; j < n; j++) {
        recorder.record({ type: 'compare', indices: [minIndex, j] });
        if (arr[j].value < arr[minIndex].value) {
          minIndex = j;
        }
      }
      if (minIndex !== i) {
        recorder.record({ type: 'swap', indices: [i, minIndex] });
        const tmp = arr[i]; arr[i] = arr[minIndex]; arr[minIndex] = tmp;
        arr[i].currentIndex = i; arr[minIndex].currentIndex = minIndex;
      }
    }

    recorder.record({ type: 'done', indices: arr.map((_, i) => i) });
    return recorder.events;
  }
}
